<template>
  <div
    class="invoice"
    :class="{ 'invoice--dashboard': dashboard}"
    v-if="invoice"
  >
    <span
      class="invoice__tag"
      v-if="dashboard"
    >
      {{ invoice.latestBilling? 'Neuste Rechnung' : 'Offene Rechnung' }}
    </span>
    <span
      class="invoice__number"
      v-if="!dashboard"
    >
     {{invoice.billingType}} #{{ invoice.billingNumber }}
    </span>
    <div class="invoice__date">
      vom {{ formatDate(invoice.billingDate) }}
    </div>
    <div class="invoice__cost">
      {{ invoice.billingAmount }} EUR
    </div>
    <div class="invoice__due-date">
      Fällig am: {{ formatDate(invoice.billingDueDate) }}
    </div>
    <!--<div class="invoice__state">
      Status: <strong>{{ getState(invoice.paid) }}</strong>
      <ag-icon
        v-if="invoice.paid"
        class="invoice__state-icon"
        modifier="check-circle"
        name="check-circle"
      />
      <ag-icon
        v-else
        class="invoice__state-icon"
        name="pending"
      />
    </div>-->
    <a
      v-if="invoice.billingDocument && !dashboard"
      download
      :href="`${invoice.billingDocument.path}`"
      class="invoice__download-link"
    >
      <ag-icon
        class="invoice__paperclip"
        name="paper-clip"
      />
      {{ invoice.billingDocument.name }}
      <ag-icon
        class="invoice__download-icon"
        name="arrow-right"
      />
    </a>
    <router-link
      v-if="dashboard"
      class="invoice__link"
      :to="{ name: 'dashboard.invoices' }"
    >
      Alle Rechnungen ansehen
    </router-link>
  </div>
</template>

<script>
import AgIcon from '@/components/shared/AgIcon.vue';

export default {
  name: 'invoice',
  components: {
    AgIcon,
  },
  props: {
    invoice: {
      type: Object,
      required: true,
    },
    dashboard: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    formatDate(date) {
      const d = new Date(date);
      const year = `${d.getFullYear()}`;
      let month = `${d.getMonth() + 1}`;
      let day = `${d.getDate()}`;

      if (month.length < 2) {
        month = `0${month}`;
      }
      if (day.length < 2) {
        day = `0${day}`;
      }

      return [day, month, year].join('.');
    },
    getState(state) {
      switch (state) {
        case true:
          return 'beglichen';
        case false:
          return 'offen';
        default:
          return '';
      }
    },
  },
};
</script>

<style lang="scss">

.invoice {
  position: relative;
  border: 2px solid #D7DDE5;
  padding: rem(12px) rem(15px);
  margin-bottom: rem(10px);
  background-color: #fff;
  box-shadow: 0 0 10px rgba(17, 42, 122, 0.161);

  &--dashboard  {
    margin-right: rem(10px);
    margin-bottom: rem(20px);

    @include mq($mq-large) {
      margin-right: rem(30px);
      margin-bottom: rem(30px);
    }
  }

  &__tag {
    display: inline-block;
    background-color: #EBEFFA;
    border-radius: rem(8px);
    color: #0B2E58;
    padding: rem(2px) rem(8px);
    font-size: rem(14px);
    font-weight: 700;
    margin-bottom: rem(10px);
  }

  &__number {
    display: inline-block;
    font-family: $copy-font;
    color: $primary-color;
    font-weight: 600;
    margin-bottom: rem(10px);
  }

  &__date {
    font-size: rem(13px);
    position: absolute;
    top: rem(12px);
    right: rem(15px);
  }

  &__cost {
    font-size: rem(18px);
    font-weight: 700;
    margin-bottom: rem(5px);
  }

  &__due-date {
    font-size: rem(14px);
    margin-bottom: rem(5px);

    @include mq($mq-large) {
      font-size: rem(15px);
    }
  }

  &__state {
    font-size: rem(14px);
    margin-bottom: rem(15px);

    @include mq($mq-medium) {
      margin-bottom: 0;
    }

    @include mq($mq-large) {
      font-size: rem(15px);
    }
  }

  &__state-icon {
    margin-left: rem(2px);
  }

  &__download-link {
    display: inline-block;
    background-color: #EBEFFA;
    color: #3169AA;
    border-radius: rem(16px);
    padding-left: rem(10px);

    @include mq($mq-medium) {
      position: absolute;
      bottom: rem(12px);
      right: rem(15px);
    }

    &:hover {
      color: #0B2E58;

      & .invoice__download-icon {
        background-color: #0B2E58;
      }
    }

    &:visited {
      color: #3169AA;
    }
  }

  &__paperclip {
    color: #666666;
  }

  &__download-icon {
    margin-left: rem(5px);
    transform: rotate(90deg);
    width: rem(32px);
    height: rem(32px);
    padding: rem(7px);
    color: #fff;
    background-color: #3169AA;
    border-radius: rem(16px);
  }

  &__link {
    display: block;
    background-color: #3169AA;
    color: #fff;
    padding: rem(12px) rem(20px);
    font-weight: 600;
    font-size: rem(15px);
    text-align: center;

    @include mq($mq-medium) {
      display: inline-block;
      position: absolute;
      bottom: rem(12px);
      right: rem(15px);
    }

    &:visited {
      color: #fff;
    }

  }
}

</style>
